import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ActiveLogo from "../img/activelogo.png";
import OvdimBariLogo from "../img/ovdim_bari_logo.png";
import MaofLaAmit from "../img/maoflaamit_logo.png"
import LeumitLogo from "../img/Leumit_Logo.png";
import { PoweredBy } from "../shared/PoweredBy";
import { isPartnerClalit, isPartnerOvdimBari, isPartnerLeumit, isPartnerNone, isPartnerMaoflaamit } from "../store/partnerStore";

const Footer = () => {
  const { t } = useTranslation();
  const isClalit = useSelector(isPartnerClalit);
  const isOvdimBari = useSelector(isPartnerOvdimBari);
  const isMaoflaamit = useSelector(isPartnerMaoflaamit);
  const isLeumit = useSelector(isPartnerLeumit);
  const isNone = useSelector(isPartnerNone);

  const [backUrl, setBackUrl] = useState("https://onelink.to/clalit_active");
  const [text, setText] = useState("");

  useEffect(() => {
    if (isClalit) {
      setBackUrl("https://onelink.to/clalit_active");
      setText(t("BACK_TO_ACTIVE"));
    } else if (isOvdimBari) {
      setBackUrl("https://ovdimbari.onelink.me/l3N5/4ju1o7by");
      setText(t("BACK_TO_OVDIM_BARI"));
    } else if (isMaoflaamit) {
      setBackUrl("https://maof.onelink.me/cVce/gifgl8hw");
      setText(t("BACK_TO_MAOFLAAMIT"));
    } else if (isLeumit) {
      setBackUrl("https://leumitfit.onelink.me/EY0x");
      setText(t("BACK_TO_LEUMIT"));
    } else {
      setBackUrl("https://meuhedetwow.onelink.me/XrAs?route=/sport");
      setText(t("BACK_TO_WOW"));
    }
  }, [isClalit, isOvdimBari, isMaoflaamit, isLeumit, t]);

  return (
    <div>
      {!isNone && !isMaoflaamit && (
        <footer
          className="main-page-footer"
          style={{ justifyContent: isClalit || isOvdimBari || isMaoflaamit || isLeumit ? "center" : "flex-start" }}
          onClick={() => window.open(backUrl)}
        >
          <p className={(isClalit || isOvdimBari || isMaoflaamit) ? "main-page-footer-text-active" : isLeumit ? "main-page-footer-text-leumit": "main-page-footer-text-wow"}>{text}</p>
          {isClalit && <img src={ActiveLogo} alt="Active logo" />}
          {(isOvdimBari) && <img src={OvdimBariLogo} alt="OvdimBari logo" />}
          {isLeumit && <img src={LeumitLogo} alt="LumitLogo logo" />}
          {isMaoflaamit && <img src={MaofLaAmit} alt="Maoflaamit logo"/>}
        </footer>
      )}
      {isClalit && <PoweredBy />}
    </div>
  );
};

export default Footer;
